var _rect, _rect2, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurgerGraphInCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#paint0_linear_156_3077)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#pattern0)",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9738 26.4676C31.0188 26.4676 26.0482 26.4676 21.0931 26.4676C20.0491 26.4676 19.9868 26.374 20.0024 24.2526C20.0336 18.7307 19.6596 19.5418 22.3397 19.5418C31.8134 19.5106 41.3028 19.5418 50.7765 19.5418C51.9763 19.5418 51.9919 19.573 51.9919 22.0064C51.9919 22.8487 51.9608 23.6598 51.9919 24.5022C52.0543 25.9684 51.7582 26.53 51.0103 26.4988C45.9929 26.4676 40.9756 26.4676 35.9738 26.4676Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0592 39.4658C32.6288 39.4658 29.1876 39.4658 25.7572 39.4658C25.0345 39.4658 24.9913 39.3671 25.0021 37.1291C25.0237 31.3038 24.7648 32.1595 26.6202 32.1595C33.179 32.1266 39.7485 32.1595 46.3073 32.1595C47.1379 32.1595 47.1487 32.1924 47.1487 34.7595C47.1487 35.6481 47.1271 36.5038 47.1487 37.3924C47.1919 38.9392 46.9869 39.5316 46.4691 39.4987C42.9955 39.4658 39.522 39.4658 36.0592 39.4658Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9738 52.4658C31.0188 52.4658 26.0482 52.4658 21.0931 52.4658C20.0491 52.4658 19.9868 52.3671 20.0024 50.1291C20.0336 44.3038 19.6596 45.1595 22.3397 45.1595C31.8134 45.1266 41.3028 45.1595 50.7765 45.1595C51.9763 45.1595 51.9919 45.1924 51.9919 47.7595C51.9919 48.6481 51.9608 49.5038 51.9919 50.3924C52.0543 51.9392 51.7582 52.5316 51.0103 52.4987C45.9929 52.4658 40.9756 52.4658 35.9738 52.4658Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_156_3077",
    transform: "translate(0 -0.207407) scale(0.000925926)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_156_3077",
    x1: 39.9333,
    y1: 83.2,
    x2: 15.8,
    y2: -32.1333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFECE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F9F8",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerGraphInCircle);
export default __webpack_public_path__ + "static/media/burgerGraphInCircle.fda3b0260a93237bb43ced754009eedf.svg";
export { ForwardRef as ReactComponent };